export function isLiveChatActive() {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const currentDay = now.getDay();

  // Define the start and end times 8 - 6
  const startHour = 8;
  let startMinute = 0;
  let endHour = 18; // 6 PM
  let endMinutes = 0;

  // Saturday and sunday 8:30 - 4:30
  if (currentDay === 0 || currentDay === 6) {
    startMinute = 30;
    endHour = 16; // 4pm
    endMinutes = 30;
  }

  // Convert current time to minutes since midnight
  const currentTimeInMinutes = currentHour * 60 + currentMinute;

  // Convert start and end times to minutes since midnight
  const startTimeInMinutes = startHour * 60 + startMinute;
  const endTimeInMinutes = endHour * 60 + endMinutes;

  // Check if the current time is within the specified range
  return (
    currentTimeInMinutes >= startTimeInMinutes &&
    currentTimeInMinutes <= endTimeInMinutes
  );
}
